/* src/app/modules/dna-syngovia/components/dna-syngovia-comparable-card-node/dna-syngovia-comparable-card-node.component.scss */
:host {
  display: block;
}
.comparable-card-container {
  width: 17.8125rem;
  min-height: 43rem;
  height: calc(100% - 2.125rem);
  padding: 1rem;
  border-radius: 0.25rem;
  border: 0.0625rem solid rgba(0, 0, 0, var(--opacity-7));
  position: sticky;
}
.form-values-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: absolute;
  width: inherit;
}
.form-values-container sh-dropdown {
  width: 100%;
}
.form-values-container sh-dropdown sh-divider:last-child {
  display: none;
}
.compare-message-container {
  z-index: -999;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
}
.compare-message-container sh-icon {
  color: rgba(0, 0, 0, 0.2);
}
.compare-message-container sh-text {
  width: fit-content;
  font-size: 1rem;
  line-height: 1.5rem;
  color: rgba(0, 0, 0, var(--opacity-4));
}
.change-container {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
}
.change-container sh-icon {
  color: rgb(var(--ui-5));
}
.change-container button {
  width: fit-content;
  padding: 0;
  font: var(--body-2);
  line-height: 1rem;
  text-decoration-line: underline;
  border: none;
  color: rgba(0, 0, 0, 0.6);
  background-color: transparent;
  cursor: pointer;
}
.details-header-container {
  display: flex;
  gap: 1rem;
}
.details-header-container .infos-container {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.details-header-container .infos-container__header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.75rem;
}
.details-header-container .tags-container {
  display: flex;
  gap: 0.5rem;
  padding-top: 0.5rem;
}
.details-header-container .tags-container sh-text {
  width: fit-content;
  padding: 0.25rem 0.5rem;
  line-height: 1.25rem;
  border-radius: 0.125rem;
  background: rgba(0, 0, 0, var(--opacity-7));
}
.device-image {
  width: 30%;
  height: 5rem;
  display: flex;
  justify-content: center;
}
.group-device-image--server {
  transform: scaleX(-1);
}
.details-card-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.detailed-infos-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.accordion .accordion-row:first-child {
  margin-top: 0.5rem;
}
.accordion-row {
  height: 1.25rem;
  display: flex;
  gap: 0.5rem;
}
.accordion-row sh-text {
  white-space: nowrap;
  width: fit-content;
}
.accordion-row-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=dna-syngovia-comparable-card-node.component.css.map */
